import { esUrlExterna, urlSinFirma } from './manifiesto';

/**
 * Texto del `console.warn` cuando el avatar no se pudo mostrar.
 *
 * La URL va sin query string: en un link firmado de R2 (§6.7) eso es la
 * firma, que no aporta al diagnóstico y no conviene copiar a un reporte.
 * Para un asset externo sugiere que el link pudo haber expirado, que es el
 * fallo esperable (R2 responde 403).
 *
 * @param avatarId el `avatar_id` del escenario, si la pantalla lo conoce.
 */
export function avisoDeFallo(url: string, error: unknown, avatarId?: string): string {
  const estado = estadoHttp(error);
  const partes = [
    `[avatar] no se pudo mostrar ${urlSinFirma(url)}`,
    avatarId !== undefined ? ` (avatar_id ${avatarId})` : '',
    estado !== undefined ? ` — HTTP ${estado}` : '',
    '.',
    esUrlExterna(url)
      ? ' Es un link externo: si es firmado, pudo haber expirado; renovarlo en el manifiesto.'
      : '',
  ];
  return partes.join('');
}

/** El status HTTP de un error de `FileLoader` de three.js (`HttpError.response`). */
function estadoHttp(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null || !('response' in error)) return undefined;
  const { response } = error;
  if (typeof response !== 'object' || response === null || !('status' in response)) {
    return undefined;
  }
  return typeof response.status === 'number' ? response.status : undefined;
}
